import {textFieldsInit} from "./text_field";
import $ from "jquery";
import {selectInit} from "./select";
import {textareaInit} from "./textarea";

const MTUIInit = function () {
  $(function () {
    textFieldsInit();
    selectInit();
    textareaInit();
    if (window.MTUIOnInitCallbacks) window.MTUIOnInitCallbacks.forEach((callback) => callback());
    window.MTUIInitialized = true;
  })
}

const MTUIOnInit = function (callback) {
  if (window.MTUIInitialized) {
    callback();
  } else {
    window.MTUIOnInitCallbacks ||= [];
    window.MTUIOnInitCallbacks.push(callback);
  }
}

const MTUIGetElement = function (id) {
  return window.MTUIElements[`mtui_${id}`];
}

export {MTUIInit, MTUIGetElement, MTUIOnInit}
